define('lib/Podio.Transport.Questions',['require','lib/Podio.Transport','lib/Podio.Config','lib/Podio.Routes'],function(require) {

  var transport = require('lib/Podio.Transport');
  var config = require('lib/Podio.Config');
  var routes = require('lib/Podio.Routes');

  function answer(question_id, ref_type, ref_id, question_option_id, isCompact, variant, callback) {
    transport.postJSON(routes.question_answer_path(question_id), {
      'requestData': {
        'ref_type': ref_type,
        'ref_id': ref_id,
        'question_option_id': question_option_id,
        'compact' : isCompact,
        'variant' : variant
      }
    }, callback);
  }

  function answerStream(question_id, ref_type, ref_id, question_option_id, callback) {
    transport.postJSON(routes.question_answer_path(question_id), {
      'requestData': {
        'question_id' : question_id,
        'ref_type': ref_type,
        'ref_id': ref_id,
        'question_option_id': question_option_id
      }
    }, callback);
  }

  function answerActivityGroup(question_id, ref_type, ref_id, question_option_id, parent_type, parent_id, event_types, callback) {
    var requestData = {
      'ref_type': ref_type,
      'ref_id': ref_id,
      'question_option_id': question_option_id,
      'variant' : 'activity_group',
      'parent_type' : parent_type,
      'parent_id' : parent_id
    };

    if (event_types) {
      requestData.event_types = event_types;
    }

    transport.postJSON(routes.question_answer_path(question_id), {
      'requestData': requestData
    }, callback);
  }

  return {
    answer: answer,
    answerStream: answerStream,
    answerActivityGroup: answerActivityGroup
  };

});



